var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-swipe-cell',{staticClass:"swipe-cell-wrapper",scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('db-col',{attrs:{"width":"auto"}},[_vm._t("swipe-slot-right")],2)]},proxy:true}],null,true)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }